// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = function (argument) {
  return typeof argument == 'function';
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/is-callable.js
// module id = 39
// module chunks = 0